import styled, { css } from 'styled-components'

export type ImageProps = {
  url?: string
}

const CardImage = styled('div')<ImageProps>`
  ${({ url, theme }) => css`
    border-radius: 100%;
    border: 1px solid ${theme.colors.grey};
    height: ${theme.components.avatar.sizes.medium};
    width: ${theme.components.avatar.sizes.medium};
    background: ${url && `url(${url}) no-repeat center/cover`};
    margin-right: ${theme.spaces[4]};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  `}
`

export default CardImage
